import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/productos-combinados")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/productos-combinados", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/industrias/productos-combinados", replace: true });
  },
});
